
  <div class="row pb-3">
    <div class="col-12">
        <kendo-editor
        #editor
        [(ngModel)]="editorHtmlContent"
        (valueChange)="htmleditorValueChange($event)"
        [iframe]="false"
        class="htmleditor"
        [pasteCleanupSettings]="pasteCleanUpSettings"
        [readonly]=isReadOnlyMode
       >
        <kendo-toolbar>
          <kendo-toolbar-buttongroup>
            <kendo-toolbar-button
              kendoEditorUndoButton
            ></kendo-toolbar-button>
            <kendo-toolbar-button
              kendoEditorRedoButton
            ></kendo-toolbar-button>
          </kendo-toolbar-buttongroup>
          <kendo-toolbar-buttongroup>
            <kendo-toolbar-button
              kendoEditorBoldButton
            ></kendo-toolbar-button>
            <kendo-toolbar-button
              kendoEditorItalicButton
            ></kendo-toolbar-button>
            <kendo-toolbar-button
              kendoEditorUnderlineButton
            ></kendo-toolbar-button>
            <kendo-toolbar-button
              kendoEditorStrikethroughButton
            ></kendo-toolbar-button>
          </kendo-toolbar-buttongroup>
          <kendo-toolbar-buttongroup>
            <kendo-toolbar-button
              kendoEditorSubscriptButton
            ></kendo-toolbar-button>
            <kendo-toolbar-button
              kendoEditorSuperscriptButton
            ></kendo-toolbar-button>
          </kendo-toolbar-buttongroup>
          <kendo-toolbar-buttongroup>
            <kendo-toolbar-button
              kendoEditorAlignLeftButton
            ></kendo-toolbar-button>
            <kendo-toolbar-button
              kendoEditorAlignCenterButton
            ></kendo-toolbar-button>
            <kendo-toolbar-button
              kendoEditorAlignRightButton
            ></kendo-toolbar-button>
            <kendo-toolbar-button
              kendoEditorAlignJustifyButton
            ></kendo-toolbar-button>
          </kendo-toolbar-buttongroup>
          <kendo-toolbar-dropdownlist
            kendoEditorFormat
          ></kendo-toolbar-dropdownlist>
          <kendo-toolbar-dropdownlist
            kendoEditorFontSize
          ></kendo-toolbar-dropdownlist>
          <kendo-toolbar-colorpicker
            kendoEditorForeColor
          ></kendo-toolbar-colorpicker>
          <kendo-toolbar-colorpicker
            kendoEditorBackColor
          ></kendo-toolbar-colorpicker>
          <kendo-toolbar-buttongroup>
            <kendo-toolbar-button
              kendoEditorInsertUnorderedListButton
            ></kendo-toolbar-button>
            <kendo-toolbar-button
              kendoEditorInsertOrderedListButton
            ></kendo-toolbar-button>
            <kendo-toolbar-button
              kendoEditorIndentButton
            ></kendo-toolbar-button>
            <kendo-toolbar-button
              kendoEditorOutdentButton
            ></kendo-toolbar-button>
          </kendo-toolbar-buttongroup>
          <kendo-toolbar-buttongroup>
            <kendo-toolbar-button
              kendoEditorCreateLinkButton
            ></kendo-toolbar-button>
            <kendo-toolbar-button
              kendoEditorUnlinkButton
            ></kendo-toolbar-button>
          </kendo-toolbar-buttongroup>
          <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
          <kendo-toolbar-buttongroup>
            <kendo-toolbar-button
              kendoEditorAddColumnBeforeButton
            ></kendo-toolbar-button>
            <kendo-toolbar-button
              kendoEditorAddColumnAfterButton
            ></kendo-toolbar-button>
            <kendo-toolbar-button
              kendoEditorAddRowBeforeButton
            ></kendo-toolbar-button>
            <kendo-toolbar-button
              kendoEditorAddRowAfterButton
            ></kendo-toolbar-button>
          </kendo-toolbar-buttongroup>
          <kendo-toolbar-button
            kendoEditorViewSourceButton
          ></kendo-toolbar-button>
          <kendo-toolbar-button
            [svgIcon]="imageIcon"
            title="Insert Image from Local File"
            (click)="triggerImageUpload($event)"
          ></kendo-toolbar-button>
          <kendo-toolbar-button
            [svgIcon]="videoIcon"
            title="Insert Video (YouTube / Vimeo)"
            (click)="openVideoDialog()"
          ></kendo-toolbar-button>
        </kendo-toolbar>
      </kendo-editor>
      <div *ngIf="imageUploadError" class="image-upload-error mt-1">{{ imageUploadError }}</div>
      <!-- <medpt-kendo-dialog #upload [editor]="editor"></medpt-kendo-dialog> -->

      <kendo-dialog
        *ngIf="showVideoDialog"
        title="Insert Video"
        [minWidth]="420"
        [width]="480"
        (close)="closeVideoDialog()"
      >
        <div class="video-dialog-body">
          <p class="video-dialog-hint">
            Only <strong>YouTube</strong> and <strong>Vimeo</strong> URLs are supported.
          </p>
          <label class="k-label" for="videoUrlInput">Video URL</label>
          <input
            id="videoUrlInput"
            type="text"
            class="k-input k-textbox k-rounded-md video-url-input"
            [(ngModel)]="videoUrl"
            name="videoUrl"
            placeholder="e.g. https://www.youtube.com/watch?v=... or https://vimeo.com/..."
            (keydown.enter)="insertVideo()"
            autocomplete="off"
          />
          <div *ngIf="videoUrlError" class="video-url-error">{{ videoUrlError }}</div>
        </div>
        <kendo-dialog-actions layout="end">
          <button kendoButton (click)="closeVideoDialog()">Cancel</button>
          <button kendoButton themeColor="primary" (click)="insertVideo()">Insert</button>
        </kendo-dialog-actions>
      </kendo-dialog>

    </div>
  </div>
